module.exports = "/_next/static/images/video_id_7129420721880698114-6b5880b3aaa6129dd34ef89bfda6c45f.jpg";